import {taxService} from "@/modules/payments/services/taxService.js";
import {scheduledPaymentsService, paymentsService} from "@/modules/payments/services";
import Vue from 'vue';

const state = {
  taxes: [],
  paymentsMap: {},
  scheduledPayments: {},
  currentPayment: {},
};

const getters = {
  currentPayment: (state) => state.currentPayment,
  taxes: (state) => state.taxes,
  scheduledPayments: (state) => (uid) => state.scheduledPayments[uid],
  getPaymentByUid: (state) => (uid) => state.paymentsMap[uid],
  engagementScheduledPayments: (state) => (engagementUid) => Object.values(state.scheduledPayments).filter((scheduledPayment) => scheduledPayment.matter_uid === engagementUid),
};

const mutations = {
  setTaxes(state, taxes) {
    state.taxes = taxes
  },
  setScheduledPayments(state, scheduledPayments) {
    state.scheduledPayments = { ...state.scheduledPayments, [scheduledPayments.uid]: scheduledPayments };
  },
  setPaymentToMap(state, payment) {
    state.paymentsMap = { ...state.paymentsMap, [payment.uid]: payment };
  },
  addNewTax(state, tax) {
    state.taxes.push(tax);
  },
}

const actions = {
  async loadTaxes({commit, state}) {
    let hasMore = true
    let page = 1;
    let taxesArray = []
    while(hasMore) {
      let taxes = await taxService.list({page: page, per_page: 25});
      Array.prototype.push.apply(taxesArray,taxes.data.taxes);
      if (taxes.data.taxes.length === 25) {
        hasMore = true;
        page++
      } else {
        hasMore = false
      }
    }
    commit('setTaxes', taxesArray)
    return taxesArray
  },
  async createTax({commit, state},tax) {
    try{
      let taxData = (await taxService.create(tax)).data
      commit('setTaxes', [...state.taxes, taxData.tax])
      return taxData.tax
    }
    catch (e) {
      return e
    }
  },
  async createScheduledPayment({commit, state}, scheduledPayment) {
    try{
      let scheduledPaymentsData = await scheduledPaymentsService.createScheduledPayment(scheduledPayment)
      commit('setScheduledPayments', scheduledPaymentsData.scheduled_payments_rule)
      return scheduledPaymentsData
    }
    catch (e) {
      return e
    }
  },
  async editScheduledPayment({commit, state}, payload) {
    try{
      let scheduledPaymentsData = await scheduledPaymentsService.editScheduledPayment(payload.uid, payload.params)
      commit('setScheduledPayments', scheduledPaymentsData.scheduled_payments_rule);
      return scheduledPaymentsData;
    }
    catch (e) {
      return e
    }
  },
  async fetchScheduledPayments({commit, state}, scheduledPaymentUid) {
    try{
      let scheduledPaymentsData = await scheduledPaymentsService.getScheduledPayments(scheduledPaymentUid)
      commit('setScheduledPayments', scheduledPaymentsData.scheduled_payments_rule)
    }
    catch (e) {
      return e
    }
  },
  async fetchFilteredScheduledPayments({commit, state}, filterBy) {
    try{
      let scheduledPaymentsData = await scheduledPaymentsService.getFilteredScheduledPayments(filterBy)
      scheduledPaymentsData.scheduled_payments_rules.forEach((scheduledPayments) => {
        commit('setScheduledPayments', scheduledPayments)
      });
      return scheduledPaymentsData;
    }
    catch (e) {
      return e
    }
  },
  async fetchPaymentByUid({commit, state}, paymentUid, force = true) {
    if (!paymentUid) {
      return Promise.reject('Payment UID is required')
    }
    // If forceFetch is true, fetch the payment from the server, otherwise return the payment from the store
    if (force || !state.paymentsMap[paymentUid]) {
      try{
        let paymentData = await paymentsService.fetchPaymentByUid(paymentUid)
        commit('setPaymentToMap', paymentData);
        return paymentData
      }
      catch (e) {
        return e
      }
    } else {
      const payment = state.paymentsMap[paymentUid]
      return Promise.resolve(payment)
    }

  },
  addNewTax({ commit }, tax) {
    commit('addNewTax', tax);
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
